import { Injectable } from '@angular/core';
import { SettingsService } from '@stockcare-services/settings-service/settings.service';
import { ActivityService } from '@stockcare-services/activity-service/activity.service';
import { ThemeService } from '@stockcare-services/theme/theme.service';
import { ConfigService } from '@stockcare-services/config-service/config.service';
import { ApplicationUpdateService } from '@stockcare-services/application-update-service/application-update.service';
import { BasketPollingService } from '@stockcare-services/basket-polling-service/basket-polling.service';
import { DeviceStatusService } from '@stockcare-services/devices-service/device-status.service';
import { WhiteboardRefreshService } from '@stockcare-services/whiteboard-service/whiteboard-refresh.service';
import { TheatreRefreshService } from '@stockcare-services/theatre-patient-service/theatre-refresh.service';
import { QueueService } from '@stockcare-services/queue-service/queue.service';
import { DoctorRefreshService } from '@stockcare-services/doctor/doctor-refresh.service';
import { ServiceRefreshService as ServicesRefreshService } from '@stockcare-services/service/service-refresh.service';
import { IHealthInformation } from '@stockcare-models/IHealthInformation';

@Injectable({
  providedIn: 'root',
})
export class PollingServicesService {
  constructor(
    private settings: SettingsService,
    private activityService: ActivityService,
    private themeService: ThemeService,
    private config: ConfigService,
    private applicationUpdateService: ApplicationUpdateService,
    private basketPollingService: BasketPollingService,
    private deviceStatusService: DeviceStatusService,
    private whiteboardRefreshService: WhiteboardRefreshService,
    private theatreRefreshService: TheatreRefreshService,
    //private doctorRefreshService: DoctorRefreshService,
    private queueService: QueueService
  ) //private servicesRefreshService: ServicesRefreshService
  {}

  initialize(): Promise<void> {
    return new Promise((resolve) => {
      this.config.configLoaded.subscribe((isLoaded) => {
        if (!isLoaded) {
          return;
        }
        this.settings.initialize().then(() => {
          this.basketPollingService.initialize();
          this.applicationUpdateService.initialize();
          this.queueService.initialize();
          // this.doctorRefreshService.initialize();
          // this.servicesRefreshService.initialize();
          this.activityService.initialize();
          this.themeService.initialize();
          this.deviceStatusService.initialize();
          //this.whiteboardRefreshService.initialize();
          this.theatreRefreshService.initialize();

          resolve();
        });
      });
    });
  }

  getHealthInformation(): IHealthInformation[] {
    const basketPollingServiceHealth = this.basketPollingService.checkHealth();
    const queueServiceHealth = this.queueService.checkHealth();

    return [basketPollingServiceHealth, queueServiceHealth];
  }
}
